import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cfp-building-report-footer',
  templateUrl: 'building-report-footer.html',
  styleUrls: ['building-report-footer.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe]
})
export class BuildingReportFooter {
  public readonly showLogo = input<boolean>(true);
  public readonly date = input<Date | undefined>(undefined);
}
